module.exports = __webpack_public_path__ + "static/aboutus-e87bd31745a40a29ad865231859d8fbb.jpg";